import {
  useRiskProfileBaseParams,
  type UseRiskProfileBaseParamsOptions,
} from './useRiskProfileBaseParams'
import type { SocialPropertiesQueryParams } from '../types/riskProfileProperties.types'

type UseSocialRiskQueryParamsOptions = Omit<UseRiskProfileBaseParamsOptions, 'metric'> & {
  demographicView: 'age' | 'ethnicity'
}

export const useSocialRiskQueryParams = ({
  demographicView,
  ...baseOptions
}: UseSocialRiskQueryParamsOptions): SocialPropertiesQueryParams | null => {
  const base = useRiskProfileBaseParams({ ...baseOptions, metric: 'population' })
  if (base === null) return null
  return { ...base, demographicView }
}
